export default {
  notifications: {
    title: 'Notifications',
    markAllAsRead: 'Mark all as read',
    today: 'Today',
    content: {
      channelFollowed: '<handle></handle> followed you!',
      contestInvited: '<handle></handle> invited you to a <contestName></contestName>!',
      contestEdited: '<handle></handle> updated <contestName></contestName> contest!',
      quickPicksContestWon: 'You won <amountWon></amountWon> in your QuickPicks contest!',
      commissionerPost: '<handle></handle> posted a message in <contestName></contestName>',
      depositBonus: '<amount></amount> <boldText>deposit match</boldText> available!',
    },
    modals: {
      // Commissioner Post Modal - specific to CONTEST_POST_MESSAGE_PUBLISHED notifications
      commissionerPost: {
        title: 'Commissioner Post',
        close: 'Close',
        goToContest: 'Go to contest',
        unsupportedNotificationType: 'This notification type is not supported.',
        content: {
          role: 'Commissioner',
          timestamp: 'Posted:',
          defaultMessage: 'You have a new message from the commissioner.',
          appDownloadPrompt:
            'To view all commissioner posts for this contest download the Splash Sports app on iOS or Android.',
        },
      },
    },
    fallbacks: {
      commissionerMessage: 'Commissioner Message',
      notificationTitle: 'Notification',
      contentNotAvailable: 'Notification content not available',
    },
  },
  noResults: {
    title: 'No notifications',
    text: 'New followers and contest invites appear here.',
  },
  readAll: 'Mark all as read',
  unsubscribe: {
    heading: "You're Unsubscribed",
    messageGeneric: 'You will no longer receive {{subscriptionGroupName}}.',
    messageSender: 'You will no longer receive {{subscriptionGroupName}} from <bold>{{senderName}}</bold>.',
    goToSplash: 'Go to Splash',
    globalError: 'Something went wrong. Please try again.',
    errors: {
      expired: {
        title: 'LINK EXPIRED',
        message:
          'This unsubscribe link has expired or is invalid. Please use the link from your most recent email.',
      },
      'not-found': {
        title: 'NOT FOUND',
        message: 'This notification category no longer exists.',
      },
      invalid: {
        title: 'INVALID REQUEST',
        message: 'Invalid request. Please use the unsubscribe link from your email.',
      },
      network: {
        title: 'SOMETHING WENT WRONG',
        message: 'Something went wrong. Please try again.',
      },
    },
  },
};
